import { ReactNode, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import BasePrinter from "../components/base-printer";

export interface PrintProps {
    documentTitle: string,
    printComponent: ReactNode,
    ignoreGlobalStyles?: boolean,
    pageStyle?: string,
    bodyClass?: string,
}

export interface usePrinterReturn {
    print: ({ documentTitle }: PrintProps) => Promise<void>;
    printRef: React.RefObject<HTMLElement>;
    printComponent: ReactNode,
    Printer: React.FC
}

export default function usePrinter(): usePrinterReturn {
    const printContainerRef = useRef<HTMLDivElement>(null);
    const [printData, setPrintData] = useState<PrintProps & { resolve: () => void }>();

    const printFn = useReactToPrint({
        contentRef: printContainerRef,
        documentTitle: printData?.documentTitle,
        onAfterPrint: printData?.resolve,
        pageStyle: printData?.pageStyle,
    });

    function print({
        documentTitle,
        printComponent,
        pageStyle,
    }: PrintProps) {
        return new Promise<void>((resolve) => {
            setPrintData({ documentTitle, printComponent, pageStyle, resolve })
        });
    }

    useEffect(() => {
        if (printData) {
            printFn();
            setPrintData(undefined);
        }
    }, [printData])

    const Printer = () => {
        return <BasePrinter printer={{ printComponent: printData?.printComponent, printRef: printContainerRef }} />
    }

    return {
        print,
        printRef: printContainerRef,
        printComponent: printData?.printComponent,
        Printer
    };
}